// toast.tsx
import { toast, Toaster, ToastPosition } from "react-hot-toast";

export function showToast(
  message: string,
  type: "success" | "error" = "success",
  position: ToastPosition = "top-right"
) {
  const options = { position };

  if (type === "success") {
    toast.success(message, options);
  } else {
    toast.error(message, options);
  }
}

export function ToastProviderHotSonner() {
  return (
    <Toaster
      position="top-right"
      containerStyle={{ zIndex: 99999 }}
      toastOptions={{
        duration: 4000,
        style: { borderRadius: 10 },
        success: {
          style: { background: "#0f5132", color: "#fff" },
          iconTheme: { primary: "#fff", secondary: "#0f5132" },
        },
        error: {
          style: { background: "#842029", color: "#fff" },
          iconTheme: { primary: "#fff", secondary: "#842029" },
        },
      }}
    />
  );
}
